export const commercialRates = ['COM']
